<template>
  <div>
    <v-data-table :headers="headersEmail" :items="devedor.emails?devedor.emails:[]">
      <template v-slot:item="props">
        <tr :class="getColor(props.item)">
          <td>{{props.item.email}}</td>
          <td>{{props.item.tipo}}</td>
          <td>
            <v-icon
              small
              class="mr-2"
              @click="editItem(props.item)">
              edit
            </v-icon>
            <v-icon
              small
              v-show="user.acesso == 'Admin'"
              @click="deleteItem(props.item)"
            >
              delete
            </v-icon>
          </td>
        </tr>
      </template>
      
    </v-data-table>

    <div class="my-2">
      <v-btn small @click.native="novo(devedor)" color="primary">Novo Email</v-btn>
    </div>
    <v-dialog v-model="dialog" persistent max-width="800">
      <v-card>
        <v-card-title class="headline">Novo Email</v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-container >
              <v-row>
                <v-col sm="6">
                  <v-text-field
                    label="E-mail"
                    v-model="model.email"
                    :rules="emailRules"
                    required
                  ></v-text-field>
                </v-col>
                <v-col sm="6">
                  <v-select :items="items" v-model="model.tipo" label="Tipo"></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col sm="12">
                  <v-checkbox label="Hot" v-model="model.hot" />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="blue darken-1" v-on:click="salvar()">Salvar</v-btn>
          <v-btn small color="red darken-1" v-on:click="dialog = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog v-model="dialogConfirmation" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Confirmação</v-card-title>
        <v-card-text>Tem certeza que deseja excluir?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="red darken-1" v-on:click="dialogConfirmation = false">Não</v-btn>
          <v-btn small color="blue darken-1" v-on:click="deleteItem(excluindo)">Sim</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapMutations } from "vuex";
  import buscacep from "@/services/buscacep";
  import emaildeve from "@/services/emaildeve";
  import devedores from "@/services/devedores";
  import usuario from "@/services/usuario"; 

  export default {
    name: 'Email',
    data () {
      return {
        
        valid: true,
        model: {},
        emailRules: [
          v => !!v || 'E-mail deve ser informado',
          v => /.+@.+\..+/.test(v) || 'E-mail não é válido.',
        ],
        dialogConfirmation:false,
        dialog: false,
        editando: false,
        excluindo: {},
        cep: {},
        user: {},
        mask: '#####-###',
        items: [
          "Pessoal",
          "Comercial"
        ],
        headersEmail: [
          {
            text: 'Email',
            align: 'left',
            sortable: true,
            value: 'email'
          },
          {
            text: 'Tipo',
            align: 'left',
            sortable: true,
            value: 'tipo'
          },
          { text: 'Ações', value: 'action', sortable: false }
        ]
      }
    },
    async mounted () {
      this.user = await usuario.getUsuario(this.$store.getters.user._id);
    },
    computed: {
      devedor() {
        return this.$store.getters["devedor"];
      },
    },
    methods: {
      novo (devedor) {
        this.model = {devedor: devedor._id};
        this.dialog = true;
      },
      async salvar () {
        if (this.$refs.form.validate()) {
          await emaildeve.save(this.model);
          this.dialog = false;
          this.setDevedor(await devedores.getDevedoreId(this.model.devedor));
          this.$forceUpdate();
        }
      },
      getColor (email) {
        if (email && email.hot) return 'red white--text';
      },
      async deleteItem (even) {
        if (!this.dialogConfirmation) {
          this.dialogConfirmation = true;
          this.excluindo = even;
        } else {
          await emaildeve.remove(even);
          this.dialogConfirmation = false;
          this.excluindo = null;
          this.setDevedor(await devedores.getDevedoreId(even.devedor));
        }
      },
      editItem: async function (even) {
        
        this.dialog = true;
        this.editando = true;
        this.model = even;
        
        this.model.internal = undefined;
        this.model.flags = undefined;
      },
      ...mapMutations({
        setDevedor: "setDevedor",
      })
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/cobranca/Email.vue